<div class="container" id="publicSearch">
  <h1>Public License Search</h1>
  <p class="lead">Welcome to the online query of DLNR-DAR Commercial Marine Licenses.  This query is to verify license
        status information of Commercial Marine Licenses issued by the Dept. of Land and Natural
        Resources (DLNR) State of Hawaii.</p>
  <ng-container *ngIf="!isSearchPerformed">
    <p class="lead">Please complete the fields you have the correct information for:</p>
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="licenseNumber">License Number</label>
            <input type="text" min="1" formControlName="licNo" name="licenseNumber" id="licenseNumber" class="form-control"
              aria-label="license number" aria-invalid="false">
            <div *ngIf="searchForm.get('licNo').hasError('validDealerId')  && !searchForm.pristine" role="alert" class="formError text-danger" aria-live="assertive">
              Please, enter a valid License Number.
            </div>

          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="firstName">First Name</label>
            <input type="text" formControlName="firstName" name="firstName" id="firstName" class="form-control"
              aria-label="first name" aria-invalid="false">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="lastName">Last Name</label>
            <input type="text" formControlName="lastName" name="lastName" id="lastName" class="form-control" aria-label="last name"
              aria-invalid="false">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="vesselName">Vessel Name</label>
            <input type="text" formControlName="vesselName" name="vesselName" id="vesselName" class="form-control"
              aria-label="vessel name" aria-invalid="false">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div *ngIf="searchForm.hasError('oneParamRequired') && (searchForm.dirty || searchForm.touched)" class="alert alert-danger" role="alert">
            <span> Please enter at least one piece of information.</span>
          </div>
          <div *ngIf="searchForm.hasError('tooManyResults') && (searchForm.dirty || searchForm.touched)" class="alert alert-danger" role="alert">
            <span> The number of search results exceeded the upper limit. Please refine your search.</span>
          </div>
          <div *ngIf="searchForm.hasError('noResultsFound') && (searchForm.dirty || searchForm.touched)" class="alert alert-danger" role="alert">
            <span> No results found. Please edit your search.</span>
          </div>
          <button type="submit" [disabled]="searchForm.touched && searchForm.invalid" class="btn btn-primary btn-space"><i class="fas fa-search"></i> Search</button>
          <button type="button" (click)="onResetClick()" class="btn btn-secondary"><i class="fas fa-times"></i>
            Clear</button>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="isSearchPerformed">
    <button class="btn btn-primary float-right" (click)="onNewSearchClick()"><i class="fas fa-search"> </i> New
      Search</button>
    <h2>Search Results</h2>
    <!--<table class="table table-bordered table-responsive-sm" [mfData]="searchResults" #mf="mfDataTable" [mfRowsOnPage]="numberOfDisplayedRows">-->
      <!--<thead class="thead-dark">-->
    <table class="table mftable table-bordered table-responsive-sm" appDatatableKeyboard [mfData]="fisherLicenses" #mf="mfDataTable" [mfRowsOnPage]="numberOfDisplayedRows">
      <thead class="thead-dark">
        <tr>
          <th [ngClass]="{'active': activeColumn === 1}">
            <mfDefaultSorter (click)="activeColumn = 1" by="licenseNumber">License #&nbsp;<i class="fa fa-sort"
                aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th [ngClass]="{'active': activeColumn === 2}">
            <mfDefaultSorter (click)="activeColumn = 2" by="lastName">Fisher Name&nbsp;<i class="fa fa-sort"
                aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th [ngClass]="{'active': activeColumn === 3}">
            <mfDefaultSorter (click)="activeColumn = 3" by="vesselName">Vessel Name&nbsp;<i class="fa fa-sort"
                aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th [ngClass]="{'active': activeColumn === 4}">
            <mfDefaultSorter (click)="activeColumn = 4" by="licenseType">License Type&nbsp;<i class="fa fa-sort"
                aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th [ngClass]="{'active': activeColumn === 5}">
            <mfDefaultSorter (click)="activeColumn = 5" by="currentStatusName">Status&nbsp;<i class="fa fa-sort"
                aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th>
            <span class="no-sortable">Exp Date</span>
          </th>
          <th [ngClass]="{'active': activeColumn === 7}">
            <mfDefaultSorter (click)="activeColumn = 7" by="businessName">Business Name&nbsp;<i class="fa fa-sort"
                aria-hidden="true"></i></mfDefaultSorter>
          </th>
        </tr>
      </thead>
      <tfoot *ngIf="!isTablePaginationHidden">
        <tr>
          <td colspan="100%" class="pagination-container">
            <mfBootstrapPaginator [rowsOnPageSet]="[10,25,50,100]"></mfBootstrapPaginator>
          </td>
        </tr>
      </tfoot>
      <tbody>
        <tr *ngFor="let item of mf.data">
          <td>{{item.licenseNumber}}</td>
          <td>{{item.lastName}}, {{item.firstName}}</td>
          <td>{{item.vesselName}}</td>
          <td>{{item.licenseType}}</td>
          <td>{{item.currentStatusName}}</td>
          <td>{{((item.currentStatusName == 'Valid') && item.expirationDate) ? (item.expirationDate | date:'mediumDate') : ''}}</td>
          <td>{{item.businessName}}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  <br> <br>
  <div class="row">
    <div class="col-md-12">
      <p><strong>Commercial marine dealers are advised:</strong></p>
      <p>
          It is unlawful to sell or offer for sale, to purchase or attempt to purchase, to exchange,
          or to act as an agent in the transfer of, any marine life taken within the jurisdiction of
          the State for commercial purpose, that is obtained directly from any person whom
          <abbr title="Department of Land and Natural Resources">DLNR</abbr> has
          required to have, but does not have, a valid Commercial Marine License report.
          (Section 189-10, Hawaii Revised Statutes (HRS))
      </p>
      <p>
        Every commercial marine dealer shall issue receipts to the person from which marine is obtained and
        shall provide the following information: date of issuance; name of person (Commercial Marine Licensee)
        to whom the receipt is issued; weight in lbs. of each marine life species received; number of marine life;
        price per pound; and with regard to aquarium fish, regardless of weight, the number and species of the fishes.
        (Section 189-11, <abbr title="Hawaii Revised Statutes">HRS</abbr>)
      </p>
      <p>
        Any dealer taking the dealer’s own marine life or handling any marine life taken by Commercial Marine Licensees
        working for or with the dealer, shall make out the same receipt, giving market price for the marine
        life as prevails on the date of receipt. A duplicate copy of this receipt shall be kept on file at the premise
        where the marine life was sold by the dealer issuing the same for a period of twelve months from
        the date of issuance, and the duplicate copy shall be available for inspection upon the demand of
        any conservation officer authorized to enforce the laws of the state.
        (Section 189-11, <abbr title="Hawaii Revised Statutes">HRS</abbr>)
      </p>
      <p>
        Please contact the Division of Aquatic Resources in Honolulu at (808) 587-0088 or 587-0564, M – F,
        7:45 AM – 4:30 PM, except State Holidays.
      </p>
    </div>
  </div>
</div>
